module.exports = __webpack_public_path__ + "img/refresh.3382e8c4.svg";